/**
 * @fileoverview CSV file generation and download utilities.
 * @module helpers/csvHelper
 */

/**
 * Converts a 2D array to CSV format and triggers a download.
 *
 * Creates a CSV file from the provided array data and automatically
 * initiates a browser download with the specified filename.
 *
 * @param {string[][]} arr - 2D array where each inner array is a CSV row
 * @param {string} fileName - The name for the downloaded file (include .csv extension)
 * @returns {void}
 *
 * @example
 * const data = [
 *   ['Name', 'Email', 'Role'],
 *   ['John', 'john@example.com', 'Admin'],
 *   ['Jane', 'jane@example.com', 'User']
 * ];
 * downloadArrayAsCSVFile(data, 'users.csv');
 */
export const downloadArrayAsCSVFile = (arr: string[][], fileName: string) => {
  let csvContent = "data:text/csv;charset=utf-8,";
  arr.forEach((rowArray) => {
    const row = rowArray.join(",");
    csvContent += row + "\r\n";
  });
  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
};
